





















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component
export default class Extras extends Vue {
    @Prop({ type: Array, required: true }) readonly data!: Array<any>;

    private selection: Array<string> = [];

    protected isSelected(index: string): boolean {
        return this.selection.includes(index);
    }

    protected select(extra: string) {
        const index = this.selection.indexOf(extra);

        if (index > -1) {
            this.selection.splice(index, 1);
        } else {
            this.selection.push(extra);
        }

        this.change();
    }

    @Emit()
    protected change(): Array<string> {
        return this.selection;
    }
}
